import { IconCode2Outline18 as Code2 } from "nucleo-ui-outline-18"

import { ShortcutSymbols } from "@productlane/lib/src/shortcut-symbols"

import type { SlashCommandDefinition } from "../types"
import { iconClassName } from "../constants"

export const codeBlockCommand: SlashCommandDefinition = {
	key: "code-block",
	title: "Code block",
	icon: <Code2 strokeWidth={1.75} className={iconClassName} />,
	command: ({ editor, range }) => {
		editor.chain().focus().deleteRange(range).setNode("codeBlock").run()
	},
	group: "blocks",
	shortcutIcons: [
		ShortcutSymbols.CMD,
		ShortcutSymbols.SHIFT,
		ShortcutSymbols["/"],
	],
}
